import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from '@cbridge-utils/react-redux';
import { GridActionDelete } from '@cbridge-tools/default-data-grid';
import { useDialogs } from '@cbridge-modules/dialog';
import { AlertSubscriptionAction } from '../../alertSubscription.action';
import { IDeleteEmailButtonProps } from './DeleteEmailButton.interface';

export const DeleteEmailButton: FunctionComponent<IDeleteEmailButtonProps> = (props) => {
  const { email } = props;

  const { t } = useTranslation();
  const dialogs = useDialogs();
  const dispatch = useDispatch();

  const handleDelete = async () => {
    const isProceed = await dialogs.confirmDelete(
      t('text:configPage.alertEmails.dialog.delete.description', '', { email }),
      {
        title: t('text:configPage.alertEmails.dialog.delete.title', '', { email }),
      },
    );

    if (isProceed) {
      dispatch(AlertSubscriptionAction.deleteEmail.started({ email }));
    }
  };

  return <GridActionDelete onClick={handleDelete} />;
};
